module.exports = {
  CUSTOMER: 'customer',
  SHIPPING_METHOD: 'shippingMethod',
  SHIPPING_ADDRESS: 'shippingAddress',
  SHIPPING_SUMMARY: 'shippingSummary',
  PAYMENT_METHOD: 'paymentMethod',
  PAYMENT_DETAILS: 'payment', // Optional stage, only shown if needed
  BILLING_ADDRESS: 'billing', // Optional stage, only shown if needed
  PLACE_ORDER: 'placeOrder',
  SUBMITTED: 'submitted',
};
